module.exports = __webpack_public_path__ + "static/media/icons8-postgresql.247d9b7f.svg";